import React, { useState, useEffect, useRef } from 'react';

import Header from './Header';
import Nav    from './Nav';
import Footer from './Footer';

import EmbedHide from '../../Common/Organism/EmbedHide';

import { checkAndOpenMenu } from '../../../Helpers/OpenMenu';



const Layout = ({ children }) => {
    const [menuVisibility, setMenuVisibility] = useState(false);
    const el                                  = useRef(null);

    const closeMenu = () => {
        setTimeout(() => setMenuVisibility(!menuVisibility), 700);
        document.body.classList.remove("menu-open");
    };

    const openMenu = () => {
        setMenuVisibility(!menuVisibility);
        document.body.classList.add("menu-open");
    };

    const handleMenuVisibilityChange = () => {
        if (menuVisibility)
            closeMenu();
        else
            openMenu();
    };

    // !(checkAndOpenMenu(menuVisibility));
    
    const addBackDrop = e => {

        if(menuVisibility && (el && !el.current.contains(e.target)))
            closeMenu();
    };

    useEffect(() => {

        window.addEventListener('click', addBackDrop);
        return () => { window.removeEventListener('click', addBackDrop) };
    }, []);

    return (
        <div>
            <EmbedHide>
                <Header 
                    setMenuVisibility = { handleMenuVisibilityChange }
                />
            </EmbedHide>        

            <div className="menu">

                <div className="menu__section" ref={el}>
                <EmbedHide>
                    <Nav menuVisibility = { menuVisibility } closeMenu = { closeMenu } />
                </EmbedHide>  
                </div>

                <main className="menu__main">
                    {children}
                </main>

            </div>
            <EmbedHide>  
                <Footer />
            </EmbedHide>  
        </div>
     );
}




export default Layout;